export default __webpack_public_path__ + "static/media/thermostat.449f3777.svg";